const UTMIFY_SCRIPT_SRC = 'https://cdn.utmify.com.br/scripts/utms/latest.js'

/**
 * Injects the official UTMify UTM tracking script.
 * Safe to call multiple times — the script is only injected once.
 */
export function loadUtmify(): void {
  if (typeof document === 'undefined') return
  if (document.querySelector(`script[src="${UTMIFY_SCRIPT_SRC}"]`)) return

  const script = document.createElement('script')
  script.src = UTMIFY_SCRIPT_SRC
  script.async = true
  script.defer = true
  script.setAttribute('data-utmify-prevent-xcod-sck', '')
  script.setAttribute('data-utmify-prevent-subids', '')
  document.head.appendChild(script)
}
